import type { TFunction } from "i18next";
import { Icon } from "../../Icon";

const WaitingTimeWidget = ({
    waitingTime,
    t
}: {
    waitingTime?: string | number,
    t: TFunction
}) => {
    if (!waitingTime) return null;

    // Determine a color based on the wait time (if it's a number)
    // Ex: > 30 min becomes orange/red
    const minutes = typeof waitingTime === 'string' ? parseInt(waitingTime) : waitingTime;
    const isHighWait = !isNaN(minutes) && minutes > 20;

    return (
        <div className="bg-base-200/20 border border-base-300/10 rounded-2xl p-5 flex items-center justify-between group transition-all hover:bg-base-200/40">
            <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-primary">
                        {t('poiModal.waitingTime')}
                    </h3>
                    {/* Button indicator to give a sense of "live" data */}
                    <span className="relative flex h-1.5 w-1.5">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-primary"></span>
                    </span>
                </div>

                <div className="flex items-baseline gap-1">
                    <p className={`text-2xl font-black tracking-tight ${isHighWait ? 'text-warning' : 'text-base-content'}`}>
                        {waitingTime}
                    </p>
                    <span className="text-xs font-bold opacity-40 uppercase">min</span>
                </div>
            </div>

            {/* Contextual icon that changes opacity on hover */}
            <div className="bg-base-100 rounded-2xl pt-4 p-3  shadow-sm border border-base-300/20 text-primary opacity-80 group-hover:opacity-100 transition-opacity">
                <Icon name="hourglass_empty" className="text-2xl" />
            </div>
        </div>
    );
};

export default WaitingTimeWidget;